export default __webpack_public_path__ + "static/media/photo--sm--38.be3f3213.jpg";